<template>
  <div>
    <CCard
      title="Vehicle Organization"
    >
      <CCardHeader>
        <CRow>
          <CCol col=4>
            <CIcon size="2xl" name="cil-grid"/> Vehicle Organization
          </CCol>
          <CCol col=8 class="align-right">
            <CButtonToolbar>
              <input 
                class="search" 
                type="search"
                v-model="findKeyword"
                v-on:input="handleKeyword"
                placeholder="ประเภท, หน่วยงาน, ทะเบียนรถ, ยี่ห้อ, รุ่น, เชื้อเพลิง"
              >
              <!-- &nbsp;
              <CButtonGroup>
                <CButton
                  v-on:click="isCreateOrEditVehicle = true; selectedVehicle = {};"
                  name="manage"
                  color="primary"
                  class="d-sm-down-none"
                >
                  Create
                </CButton>
                
              </CButtonGroup> -->
            </CButtonToolbar>
          </CCol>
        </CRow>

      </CCardHeader>
      <CCardBody>
        <CDataTable
          :hover="false"
          :striped="true"
          :border="true"
          :small="false"
          :fixed="false"
          :items-per-page="20"
          :dark="false"
          pagination
          :items="vehiclesTable"
          :fields="vehiclesTableFields"
        >
          
        </CDataTable>
      </CCardBody>
    </CCard>
        
    <Snackbar :isActivated="isAlert" :message="alertMessage" :color="alertColor"></Snackbar>

  </div>
</template>

<script>
import config  from '@/config'
import { axiosInstance } from '@/api'
// import { range, parseQueryString, parseBoolString, stringToHex } from '@/utils'

import Snackbar from '@/vue/base/Snackbar.vue'
import CCmonth from '@/vue/base/CCmonth.vue'
import CCNumber from '@/vue/base/CCNumber.vue'

import '@/assets/scss/search_box.scss'

import Ajv from "ajv"
import { TRUE } from 'sass'

// import { CInput } from '@coreui/vue'

const ajv = new Ajv()

export default {
  name: 'Vehicle',
  components: { Snackbar, CCmonth, CCNumber },
  data () {
    return {
      numberValue: 0,
      isDeletabled: false,
      isManageInfo: false,
      isManageVehicle: false,
      isCreateOrEditVehicle: false,
      isManageUsage: false,
      isCreateOrEditUsage: false,
      isAlert: false,
      alertCountDown: 0,
      alertColor: 'info',
      alertMessage: '',
      findKeyword: '',
      // feedback: {},
      // user: {},
      VehicleSchema: {},
      vehicle: {},
      vehicles: [],
      selectedVehicle: {},
      vehiclesTableFields:  [
        { key: 'type', label: 'ประเภท' },
        { key: 'department', label: 'หน่วยงาน' },
        { key: 'plate_number', label: 'ทะเบียนรถยนต์' },
        { key: 'brand', label: 'ยี่ห้อ' },
        { key: 'model', label: 'รุ่น' },
        { key: 'fuel_type', label: 'ชนิดเชื้อเพลิง' },
        { key: 'engine_size', label: 'ขนาดเครื่องยนต์' },
        { key: 'battery_size', label: 'ขนาดแบตเตอรี่' },
        { key: 'email', label: 'ผู้กรอกข้อมูล' }
      ],
      // UsageSchema: {},
      // usage: {},
      // usages: [],
      // selectedUsage: {},
      // usagesTableFields:  [
      //   { key: 'month', label: 'เดือน' },
      //   { key: 'distance', label: 'ระยะทาง' },
      //   { key: 'fuel', label: 'ปริมาณเชื้อเพลิง' },
      //   { key: 'electric', label: 'ปริมาณไฟฟ้า' },
      //   { key: 'email', label: 'ผู้กรอกข้อมูล' }
      // ],
      selectFuelTypeOption: [
        {
          value: 'electric',
          label: 'ไฟฟ้า'
        },
        {
          value: 'hybrid',
          label: 'ไฮบริด'
        },
        { 
          value: 'bensin', 
          label: 'เบนซิน'
        },
        { 
          value: 'e85', 
          label: 'E85'
        },
        { 
          value: 'e20', 
          label: 'E20'
        },
        { 
          value: 'diesel', 
          label: 'ดีเซล'
        },
        { 
          value: 'lpg', 
          label: 'LPG'
        },
        { 
          value: 'ngv', 
          label: 'NGV'
        },
      ],
      selectVehicleTypeOption: [
        { 
          value: 'vehicle_01', 
          label: 'รถยนต์ที่นั่งส่วนบุคคลไม่เกิน 7 คน'
        },
        { 
          value: 'vehicle_02', 
          label: 'รถยนต์ที่นั่งส่วนบุคคลเกิน 7 คน'
        },
        { 
          value: 'vehicle_03', 
          label: 'รถยนต์บรรทุกส่วนบุคคล'
        },
        { 
          value: 'vehicle_04', 
          label: 'รถยนต์สามล้อส่วนบุคคล'
        },
        { 
          value: 'vehicle_05', 
          label: 'รถยนต์รับจ้างระหว่างจังหวัด'
        },
        { 
          value: 'vehicle_06', 
          label: 'รถยนต์ที่รับจ้างบรรทุกคนโดยสารไม่เกิน 7 คน'
        },
        { 
          value: 'vehicle_07', 
          label: 'รถยนต์สี่ล้อเล็กรับจ้าง'
        },
        { 
          value: 'vehicle_08', 
          label: 'รถยนต์รับจ้างสามล้อ'
        },
        { 
          value: 'vehicle_09', 
          label: 'รถยนต์บริการธุรกิจ'
        },
        { 
          value: 'vehicle_10', 
          label: 'รถยนต์บริการทัศนาจร'
        },
        { 
          value: 'vehicle_11', 
          label: 'รถยนต์บริการให้เช่า'
        },
        { 
          value: 'vehicle_12', 
          label: 'รถจักรยานยนต์ส่วนบุคคล'
        },
        { 
          value: 'vehicle_13', 
          label: 'รถแทรกเตอร์'
        },
        { 
          value: 'vehicle_14', 
          label: 'รถบดถนน'
        },
        { 
          value: 'vehicle_15', 
          label: 'รถใช้งานเกษตรกรรม'
        },
        { 
          value: 'vehicle_16', 
          label: 'รถพ่วง'
        },
        { 
          value: 'vehicle_17', 
          label: 'รถจักรยานยนต์สาธารณะ'
        },
      ],
      selectOwnershipOption: [
        { 
          value: 'own', 
          label: 'รถซื้อ'
        },
        { 
          value: 'rent', 
          label: 'รถเช่า'
        },
      ],
      selectReplacementOption: [
        { 
          value: '', 
          label: 'ไม่มี (พาหนะใหม่)'
        },
        { 
          value: 'ice', 
          label: 'รถน้ำมัน'
        },
        { 
          value: 'ev', 
          label: 'รถไฟฟ้า'
        },
        { 
          value: 'hybrid', 
          label: 'รถไฮบริด'
        },
      ],
      // usageCounts: {},
      // selectManufacturingYearOption: [
      // ],
    }
  },
  computed: {
    // isValidBatterySize () {
    //   if (this.requiredBatterySize) {
    //     if (this.selectedVehicle.battery_size) {
    //       return this.isValidVehicle('battery_size')
    //     } else {
    //       return false
    //     }
    //   } else {
    //     return true
    //   }
    // },
    // isValidEngineSize () {
    //   if (this.requiredEngineSize) {
    //     if (this.selectedVehicle.engine_size) {
    //       return this.isValidVehicle('engine_size')
    //     } else {
    //       return false
    //     }
    //   } else {
    //     // console.log('isValidEngineSize = true')
    //     return true
    //   }
    // },
    // requiredEngineSize () {
    //   switch (this.selectedVehicle.fuel_type) {
    //     case 'diesel':
    //     case 'bensin':
    //     case 'e20':
    //     case 'e85':
    //     case 'lpg':
    //     case 'ngv':
    //     case 'hybrid':
    //       return true
    //     default:
    //       return false
    //   }
    // },
    // requiredBatterySize () {
    //   switch (this.selectedVehicle.fuel_type) {
    //     case 'electric':
    //     case 'hybrid':
    //       return true
    //     default:
    //       return false
    //   }
    // },
    vehiclesTable () {
      let vehicles = []
      for(let i = 0; i < this.vehicles.length; i++) {
        let vehicle = Object.assign({},this.vehicles[i])

        vehicle['type'] = this.findLabelByValue(this.selectVehicleTypeOption , vehicle['type'])
        vehicle['fuel_type'] = this.findLabelByValue(this.selectFuelTypeOption, vehicle['fuel_type'])
        vehicle['engine_size'] = vehicle['engine_size'] ?? ''
        vehicle['battery_size'] = vehicle['battery_size'] ?? ''

        // ### move user-email to email
        vehicle['email'] = vehicle['user']['email']
        delete vehicle['user']

        vehicles.push(vehicle)
      }
      
      let filteredVehicles = []
      for(let i = 0; i < vehicles.length; i++) {
        if (
          vehicles[i]['type'].includes(this.findKeyword)
          || vehicles[i]['department'].includes(this.findKeyword)
          || vehicles[i]['plate_number'].includes(this.findKeyword)
          || vehicles[i]['brand'].includes(this.findKeyword)
          || vehicles[i]['model'].includes(this.findKeyword)
          || vehicles[i]['fuel_type'].includes(this.findKeyword)
        ) {
          filteredVehicles.push(vehicles[i])
        }
      }
      return filteredVehicles
    },
    // isValidSelectedVehicle () {
    //   const isValid = ajv.validate(this.VehicleSchema, this.selectedVehicle)
    //   if (!isValid) { 
    //     return false
    //   } else {
    //     return true
    //   }
    // },
    // isValidSelectedUsage () {
    //   const isValid = ajv.validate(this.UsageSchema, this.selectedUsage)
    //   if (!isValid) { 
    //     return false
    //   } else {
    //     return true
    //   }
    // },
    // isNewVehicle () {
    //   if(Object.hasOwn(this.selectedVehicle, 'id')) {
    //     if (typeof this.selectedVehicle.id === 'number') {
    //       return false
    //     }
    //   }
    //   return true
    // },
  },
  mounted() {
    this.checkUserOrganization()
    this.getVehicleOrganization()
  },
  watch: {
  },
  methods: {
    findLabelByValue(options, searchValue) {
      const foundOption = options.find(option => option.value === searchValue)
      return foundOption ? foundOption.label : ''
    },
    handleKeyword () {
      // Nothing to do, the keyword is used in computed()
    },
    checkUserOrganization () {
      axiosInstance({
        method: 'get',
        url: '/user/getOrCreate',
      })
      .then(response => {
        if(response.status === 200 || response.status === 201) {
          // console.log('/user/getOrCreate response-data: '+JSON.stringify(response.data, null, 2))
          this.user = response.data
          // if (typeof this.user.organizationId === 'number') {
          //   this.getOrganizationOfyourself()
          // } else {
          if (!this.user.organizationId) {
            this.alertColor = 'danger'
            this.alertMessage = 'Please update your organization'
            this.isAlert = !this.isAlert
          }
        } 
      })
      .catch(error => {
        console.log(error)
        if (error.response) {
          console.log(`Error [${error.response.status}]: ${JSON.stringify(error.response.data, null, 2)}`)
        }
      })
    },
    getVehicleOrganization () {
      axiosInstance({
        method: 'get',
        url: '/vehicle/organization'
      })
      .then(response => {
        // console.log(`get Vehicle: ${JSON.stringify(response.data, null, 2)}`)
        if(response.status === 200) {
          this.vehicles = response.data
        }
      })
      .catch(error => {
        console.log(error)
        if (error.response) {
          console.log(`Error [${error.response.status}]: ${JSON.stringify(error.response.data, null, 2)}`)
        }
      })
    },
    // getVehicle () {
    //   axiosInstance({
    //     method: 'get',
    //     url: '/vehicle/'
    //   })
    //   .then(response => {
    //     // console.log(`get Vehicle: ${JSON.stringify(response.data, null, 2)}`)
    //     if(response.status === 200) {
    //       this.vehicles = response.data
    //     }
    //   })
    //   .catch(error => {
    //     console.log(error)
    //     if (error.response) {
    //       console.log(`Error [${error.response.status}]: ${JSON.stringify(error.response.data, null, 2)}`)
    //     }
    //   })
    // },

  }
}
</script>

<style scoped lang="scss">
  // .table-header {
  //   font-size: 1rem;
  //   margin-bottom: -15px;
  // }

  /* Center align content in the first column */
  .align-center {
    // text-align: center;
    display: flex;
    align-items: center; /* Vertical alignment */
    justify-content: center; /* Horizontal alignment */
  }

  /* Right align content in the second column */
  .align-right {
    display: flex;
    align-items: right; /* Vertical alignment */
    justify-content: right; /* Horizontal alignment */
  }

  .button-wrapper {
    position: relative;
    display: inline-block;
  }

  .badge {
    position: absolute;
    
    background-color: red;
    color: white;
    border-radius: 50%;
    font-size: 20px;
    width: 30px;
    height: 30px;
    top: -10px;
    right: -12px;
    // ### original size
    // font-size: 12px;
    // width: 20px;
    // height: 20px;
    // top: -5px;
    // right: -10px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: bold;
  }
</style>